/*
 * This file is an extension of the regular utils file, but contains utils that are also needed by
 * the crossbrowser util file. These have been moved into this shared file to avoid issues with
 * circular dependencies. Any new utils should be added to the main util file, unless they are
 * needed by the crossbrowser util file as well.
 */

export function isEmptyTokenOrSeparator(node: Element): boolean {
    // TODO(Rifdhan) this is needed for unit tests, figure out a better mocking strategy instead
    if (!node || node.textContent === null) {
        return false;
    }

    return node.textContent.length === 0;
}
